module.exports = __webpack_public_path__ + "img/img_brand21.9124c450.jpg";